import { Link } from '@umijs/max';
import React from 'react';
import { Badge } from 'antd';
import { getLocalStorageItem } from '@/utils';


type MenuItemProps = {
  children: any;
  path: string;
  target?: string;
};

// 菜单角标计数配置：group 对应 ticketStatusCount 下的 ticket 类型，key 对应计数字段
const showBadgeMenuCountMap: Record<string, { group: string; key: string }> = {
  "/email-ticket/all": { group: "email_ticket", key: "all_unresolved" },
  "/email-ticket/unallocated": { group: "email_ticket", key: "unassigned" },
  "/email-ticket/unprocessing": { group: "email_ticket", key: "pending" },
  "/email-ticket/pending": { group: "email_ticket", key: "unconfirmed" },
  // "/email-ticket/resolved": { group: "email_ticket", key: "resolved" },
  // "/email-ticket/third-party": { group: "email_ticket", key: "wait_for_third_count" },
  "/saas-ticket/all": { group: "saas_ticket", key: "all_unresolved" },
  "/saas-ticket/unallocated": { group: "saas_ticket", key: "unassigned" },
  "/saas-ticket/unprocessing": { group: "saas_ticket", key: "pending" },
  "/saas-ticket/pending": { group: "saas_ticket", key: "unconfirmed" },
  // "/saas-ticket/resolved": { group: "saas_ticket", key: "resolved" },
};

const MenuItem: React.FC<MenuItemProps> = ({ path, children, target }) => {
  const res = getLocalStorageItem('ticketStatusCount') || {};
  const badgeConfig = showBadgeMenuCountMap[path];
  if(badgeConfig){
    return <Link to={path || '/'} target={target}>
      <div className='qd-w-full qd-flex qd-justify-between qd-items-center qd-pr-1' >
        <div className='qd-mr-2' >{children}</div>
        <Badge count={res?.[badgeConfig.group]?.[badgeConfig.key] || 0} overflowCount={1000}></Badge>
      </div>
    </Link>;
   }
  // !NOTE 扩展，可以让指定 tab 跳转至新浏览器 tab 窗口
  // 可以结合 tabList 缓存，来指导当前用户是否需要新窗口打开
  return (
    <Link to={path || '/'} target={target}>
      {children}
    </Link>
  );
};

export default MenuItem;
